import { render } from "./GlobalRoleBindings.vue?vue&type=template&id=92d0491e&scoped=true"
import script from "./GlobalRoleBindings.vue?vue&type=script&lang=js"
export * from "./GlobalRoleBindings.vue?vue&type=script&lang=js"

import "./GlobalRoleBindings.vue?vue&type=style&index=0&id=92d0491e&lang=scss"
import "./GlobalRoleBindings.vue?vue&type=style&index=1&id=92d0491e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d0491e"]])

export default __exports__